<template>
  <div class="col-lg-12">
    <div class="team-section">
      <div class="row">
        <div v-if="float==='left'" class="col-12 col-md-5 col-lg-5 col-xl-5 member-image d-none d-md-block d-lg-block d-xl-block">
          <img v-bind:src="getSrc('team/' + member.image)" alt=""/>
        </div>
        <div class="col-12 member-image d-block d-sm-block d-md-none d-xl-none d-lg-none">
          <img v-bind:src="getSrc('team/' + member.image)" alt=""/>
        </div>
        <div class="col-12 col-md-7 col-lg-7 col-xl-7 text">
          <div class="head">
            <span v-if="member.link">
            <a v-bind:href="member.link.url" class="linked-in-link" target="_blank">
              {{ $t(member.name) }}<img class="linked-in-url" v-bind:src="getSrc('social/ln.png')" alt="">
            </a>
            </span>
            <div v-if="member.position" class="position">
              {{ $t(member.position) }}
            </div>
          </div>
          <div class="info">
            {{ $t(member.description) }}
          </div>
        </div>
        <div v-if="float==='right'" class="col-12 col-md-5 col-lg-5 col-xl-5 member-image d-none d-md-block d-lg-block d-xl-block">
          <img v-bind:src="getSrc('team/' + member.image)" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageMixin from '../mixins/image'

export default {
  name: 'TeamMember',
  props: ['member', 'float'],
  mixins: [imageMixin]
}
</script>

<style scoped lang="scss">
.team-section {

  box-sizing: border-box;
  border-radius: 10px;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 20px;
  margin-top: 20px;
  font-style: normal;
  padding-left: 12px;
  max-width: 1060px;

  .text {
    margin-top: 10px;
    margin-bottom: 10px;

    .head {
      font-weight: bold;
      font-size: 25px;
      line-height: 30px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin-bottom: 10px;

      .position {
        font-size: 24px;
        line-height: 30px;
      }
    }

    .info {
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      text-align: justify;

    }
  }

  .linked-in-link {
    text-decoration: none;
    margin-top: 3px;
    margin-bottom: 5px;
    color: #000000 !important;

    .linked-in-title {
      margin-left: 15px;
    }
  }

  .member-image {
    text-align: center;

    img {
      width: 100%;
      max-width: 275px;
      border-radius: 50%;
    }
  }

  .linked-in-url
  {
    max-height: 30px;
    margin-left: 5px;
    margin-top: -5px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .team-section {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .col-12 {
    padding-left: 0 !important;
  }
}
</style>
